export const ENTITY_PROFILE_INPUT_MAX_LENGTH = 256

export const ENTITY_PROFILE_EDIT_INPUT_MIN_ROWS = 4
